module.exports = __webpack_public_path__ + "static/media/Knowing my workplace literacy and numeracy.912c0b00.pdf";